import AminoPosts from '~content/work/posts/amino/amino-posts.jsx';
import * as React from 'react';
export default {
  AminoPosts,
  React
};